import { render, staticRenderFns } from "./resourcedDetails.vue?vue&type=template&id=3f76703c&scoped=true&"
import script from "./resourcedDetails.vue?vue&type=script&lang=js&"
export * from "./resourcedDetails.vue?vue&type=script&lang=js&"
import style0 from "./resourcedDetails.vue?vue&type=style&index=0&id=3f76703c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76703c",
  null
  
)

export default component.exports